@if (vm.isLoading) {
  @if (vm.showTimeoutMessage) {
    <section class="flex flex-row gap-8 mb-32">
      <app-loading-spinner variant="blue" [size]="20" />
      <p class="body">Sorry, it’s taking longer than usual.</p>
    </section>
  }
  <app-skeleton-loader class="dark full-width max-w-120 h-40 sm-h-32" />
  <app-skeleton-loader class="dark full-width h-40 sm-h-32 mt-24 sm-mt-16" />
  <app-skeleton-loader class="dark full-width h-40 sm-h-32 mt-8" />
  <app-skeleton-loader class="dark full-width h-40 sm-h-32 mt-8" />
} @else if (vm.isError) {
  <section class="flex flex-row gap-8 items-center">
    <i class="fa-light fa-circle-exclamation fa-lg" style="color: #aa6804"></i>
    <h2 class="heading-4 bold">Repair history</h2>
  </section>

  <section class="info-box mt-24 p-16">
    <p class="body">
      We’re having some issues loading your past repairs. Please
      <button class="link-text pointer" (click)="retry()">check again</button> later
    </p>
  </section>
} @else {
  <h2 class="heading-4 bold" data-testid="history-heading">Repair history</h2>

  @if (vm.isEmpty) {
    <p class="body mt-12 sm-mt-8">You will be able to see all completed bookings or appointments here.</p>
  }

  <section class="flex-col mt-24 sm-mt-16 gap-8">
    @for (visit of vm.entries; track visit.claimId; let index = $index; let first = $first) {
      <section class="panel" [class.open]="vm.openPanels[index]" data-testid="history-entry">
        <section class="header">
          <button
            class="block full-width label p-16"
            data-testid="history-entry-toggle"
            [disabled]="visit.failedToLoad"
            (click)="updateOpenPanels(index)"
          >
            <div class="sm-flex-col">
              <span class="bold border-right w-136 inline-block label" data-testid="history-entry-date">{{
                visit.states[0].statusChangeDateTime | date: 'dd MMM yyyy'
              }}</span>
              <span class="label" style="font-weight: 400" data-testid="history-entry-status">{{
                visit.states[0].status
              }}</span>
            </div>

            @if (!visit.failedToLoad) {
              <i
                class="fa-light ml-8"
                [class.fa-chevron-up]="vm.openPanels[index]"
                [class.fa-chevron-down]="!vm.openPanels[index]"
              ></i>
            }
          </button>
        </section>

        <section class="content flex-col" [appAnimateOpen]="vm.openPanels[index]">
          @for (step of visit.states; track step.statusChangeDateTime; let first = $first) {
            @if (!first) {
              <section class="step flex sm-flex-col pl-16 pr-16 full-width" data-testid="history-step">
                <p class="label border-right w-136 bold">
                  {{ step.statusChangeDateTime | date: 'dd MMM yyyy' }}
                </p>
                <p style="font-weight: 400" class="label">
                  {{ step.status }}
                </p>
              </section>
            }
          }
        </section>
      </section>
    } @empty {
      <section class="no-history" data-testid="no-history">
        <i class="fa-light fa-circle-dashed"></i>
        <p class="body">You have no previous bookings.</p>
      </section>
    }
  </section>
  @if (vm.showExpandOption) {
    <hr class="mt-24 mb-20" />

    <app-button
      dataLabel="show-more-dates"
      class="show-more"
      [buttonOptions]="{ variant: 'link', fill: false }"
      (onClick)="showFullList.set(!showFullList())"
    >
      <span class="body bold">{{ showFullList() ? 'Show less dates' : 'Show more dates' }}</span>
      <i class="fa-light ml-8" [class.fa-chevron-up]="showFullList()" [class.fa-chevron-down]="!showFullList()"></i
    ></app-button>
  }
}
